import React from 'react';
import styles from './Footer.module.scss';
import fb from './fb.png';
import ig from './ig.png';
import mail from './mail.png';

const social = [
  {
    platform: 'Facebook',
    image: fb,
    link: 'https://www.facebook.com/diamourjewelry/'
  },
  {
    platform: 'Instagram',
    image: ig,
    link: 'https://www.instagram.com/diamourjewellery/'
  },
  {
    platform: 'Email',
    image: mail,
    link: 'mailto:shivani@diamour.in'
  }
];

const Footer = props => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <footer className={styles.footer}>
      {social.map((item, i) => 
        <a
          className={styles.link}
          href={item.link}
          key={i}
        >
          <img
            src={item.image}
            alt={item.platform}
          />
        </a>
      )}
      <span className={styles.copyright}>
        {`Diamour ©${year}`}
      </span>
    </footer>
  );
};

export default Footer;
